import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	// getVariableManagements: ({ varVal, strtDt, currentPage, pageUnit }) => {
	// 	if (!varVal) return false;
	// 	let queryStr = '';

	// 	console.log('asd', varVal, strtDt);

	// 	if (varVal !== undefined || strtDt !== undefined) {
	// 		queryStr = objectToQuerystring({
	// 			varVal: varVal,
	// 			useYn: 'Y',
	// 			strtDt: strtDt,
	// 			currentPage,
	// 			pageUnit
	// 		});
	// 	}
	// 	console.log('queryStr', queryStr);

	// 	return client
	// 		.get(`${BASE_URL}/comm/qmsbase/variable/v1/variables` + queryStr)
	// 		.then(response => {
	// 			return response?.data.body.resultList;
	// 		})
	// 		.catch(error => {
	// 			throw error.response.data;
	// 		});
	// },
	async getCommCodes(codeType) {
		//console.log('codeType', codeType);
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getRoApcnList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		/*날짜 포멧변환*/
		let roStartDt, roEndDt, causPartNo;

		//날짜 값이 없으면 날짜 포멧을 할수가 없다.
		if (searchParams.roStartDt) {
			roStartDt = moment(searchParams.roStartDt).format('YYYYMMDD');
		} else {
			roStartDt = '';
		}

		if (searchParams.roEndDt) {
			roEndDt = moment(searchParams.roEndDt).format('YYYYMMDD');
		} else {
			roEndDt = '';
		}

		/*특수문자가 있는것들은 다음과 같이해줘됨 */
		if (searchParams.causPartNo) {
			causPartNo = encodeURIComponent(searchParams.causPartNo);
		} else {
			causPartNo = '';
		}
		
		queryStr = objectToQuerystring({
			roNo: searchParams.roNo /*roNo*/,
			dlrCpnyCd: searchParams.dlrCpnyCd /*딜러점*/,
			prcStepGb: searchParams.prcStepGb /*처리단계*/,
			prcRsltCd: searchParams.prcRsltCd /*처리결과*/,
			ceqType: searchParams.ceqType /*정비유형*/,
			prcPwaDd: searchParams.prcPwaDd /*날짜검색구분값from*/,
			ctype: searchParams.ctype /*ctype*/,
			rptpStCd: searchParams.rptpStCd /*ctype*/,
			causPartNo: causPartNo /*품번*/,
			roStartDt: roStartDt /*신청일자from*/,
			roEndDt: roEndDt /*신청일자to*/,
			cmpnNo: searchParams.cmpnNo /*켐페인번호 */,
			aplcNm: searchParams.aplcNm /*신청자*/,
			carVin: searchParams.carVin,
			pmcId:searchParams.pmcId,
			causOpCd: searchParams.causOpCd,
			outBoundStatus: "Y" == searchParams.outBoundStatus? '1' : "N" == searchParams.outBoundStatus ? '0' : '',
			currentPage,
			pageUnit
		});

		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/roApcns` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getPwaApcnPopList(objParam) {
		let paramPwaNo = objParam.pwaNo;

		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/pwaNo/${paramPwaNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	chkPmcIdCampNo: param => {
		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/chkPmcIdCampNo/pmcId/${param}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getRoApcnPopList(paramRoNo) {
		//console.log('RO번호>>>', paramRoNo);

		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/roNo/${paramRoNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	saveRoApcnPopup: ({ formData }) => {
		let url = `${BASE_URL}/mqy/ceqi/roApcn/v1/status/1/`;

		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	delApcnRoSwapInfoList: paramDelList => {
		let url = `${BASE_URL}/mqy/ceqi/roApcn/v1/status/3/apcnRoSwapInfoList`;

		return client
			.post(url, paramDelList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	fileDownload: ({ params }) => {
		//console.log('params', params);
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downloadFiles`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	},
	saveStateAppr: ({ roApcnPopUp }) => {
		return client
			.post(
				`${BASE_URL}/mqy/ceqi/roApcn/v1/status/2/roNo/${roApcnPopUp.roNo}/pmcId/${roApcnPopUp.pmcId}/milg/${roApcnPopUp.milg}/causPartNo/${roApcnPopUp.causPartNo}/selCtype/${roApcnPopUp.ctype}/apprA`
			)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	apprDupCnt: ({ roApcnPopUp }) => {
		return client
			.post(
				`${BASE_URL}/mqy/ceqi/roApcn/v1/status/1/roNo/${roApcnPopUp.roNo}/pmcId/${roApcnPopUp.pmcId}/milg/${roApcnPopUp.milg}/causPartNo/${roApcnPopUp.causPartNo}/selCtype/${roApcnPopUp.ctype}/chkDupCnt`
			)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	deleteRoApcnPopup: delParam => {
		let queryStr = '';

		//console.log('delParam', delParam);

		queryStr = objectToQuerystring({
			roFileId: delParam.roFileId /*fileId*/
		});

		//console.log('api CallUrl', `${BASE_URL}/mqy/ceqi/roApcn/v1/status/3/roNo/${delParam.roNo}` + queryStr);

		return client
			.post(`${BASE_URL}/mqy/ceqi/roApcn/v1/status/3/roNo/${delParam.roNo}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	checkPwa: param => {
		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/pwaPreReg/pmcId/${param.pmcId}/causPartNo/${param.causPartNo}/milg/${param.milg}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//팝업 pwa과 RO에서 사용년월 가져오는걸동시에 사용함
	getRoUsedYear: param => {
		let queryStr = '';
		//console.log('popupSearchParams', popupSearchParams);
		/*
		oemSaleD: moment(param.oemSaleD).format('YYYYMMDD'), //OEM판매일자.
				dgnDd: moment(this.pwaApcnPopUp.dgnDd).format('YYYYMMDD') //진단일자.
		*/

		queryStr = objectToQuerystring({
			oemSaleDd: param.oemSaleD, //OEM판매일자.
			dgnDd: param.dgnDd //진단일자.,
		});

		//console.log('여기니queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/ceqi/pwaApcn/v1/pwaUsedYear` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},

	/*******************************************얼그레이아이스티 ******************************/

	//캠페인 팝업 캠페인 그리드 조회
	getCmpnMstList: param => {
		let queryStr = '';
		if (param !== undefined) {
			queryStr = objectToQuerystring({
				cmpnNo: param.cmpnNo,
				pmcId: param.pmcId
			});
		}
		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/popupCmpnList` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//캠페인 팝업 OP코드 그리드 조회
	getCmpnMstPopList(param) {
		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnNo/${param}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//캠페인 팝업 교환부품정보 그리드 조회
	getSearchCmpnPartList(param) {
		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnPart/cmpnNo/${param.cmpnNo}/opCd/${param.opCd}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//차량정보조회 유무 조회
	//차량정볼를 왜 조회하는지 모르겠음?
	getPopupCarSales: ({ param, currentPage, pageUnit }) => {
		let queryStr = '';
		if (param.pmcId !== undefined) {
			queryStr = objectToQuerystring({
				pmcId: param.pmcId,
				cmpnNo: param.cmpnNo,
				roApcnch: param.roApcnch,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/mqy/qlty/carSale/v1/carSales` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	apprSaveRoList: ({ formData }) => {
		let url = `${BASE_URL}/mqy/ceqi/roApcn/v1/status/1/roApprList`;

		return client
			.post(url, formData)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	apprSaveRoOutBound: ({ formData }) => {
		let url = `${BASE_URL}/mqy/ceqi/roApcn/v1/status/2/roNo/outBound`;

		return client
			.post(url, formData)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	addCostUpload: ({ formData }) => {
		const url = `${BASE_URL}/mqy/ceqi/roApcn/v1/status/2/roNo/costUpload`;

		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				console.log("error: ",  error);
				throw new Error(error.response.data);
			});
	},
	roCostMatch: () => {
		const url = `${BASE_URL}/mqy/ceqi/roApcn/v1/status/2/roNo/roCostMatch`;

		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
	/*******************************************얼그레이아이스티 ******************************/
};
